import React, { useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import ImageOne from "../../assets/QuoteIcons/image1.png";
import ImageTwo from "../../assets/QuoteIcons/image2.png";
import ImageThree from "../../assets/QuoteIcons/image3.png";
import Logo from "../../assets/QuoteIcons/image4.png";
import QRCode from "../../assets/qr-code.png";
import MobileImageOne from "../../assets/image8.png";
import MobileImageTwo from "../../assets/image9.png";
import Appstore from "../../assets/Appstore.png";
import Playstore from "../../assets/Playstore.png";
import CloseIcon from "@mui/icons-material/Close";

const QuoteData = [
  {
    image: ImageOne, // Directly pass the imported path
    carrier: "UPS",
    service: "World Saver",
    fromCountry: "India",
    dimensionL: "8",
    dimensionH: "12",
    dimensionW: "12",
    weight: "2.5",
    deliveryTime: "2-6",
    price: "289.99",
  },
  {
    image: ImageTwo, // Directly pass the imported path
    carrier: "FedEx",
    service: "International Connect",
    fromCountry: "India",
    dimensionL: "8",
    dimensionH: "12",
    dimensionW: "12",
    weight: "2.5kg",
    deliveryTime: "2-6",
    price: "289.99",
  },
  {
    image: ImageThree, // Directly pass the imported path
    carrier: "DHL",
    service: "Express",
    fromCountry: "India",
    dimensionL: "8",
    dimensionH: "12",
    dimensionW: "12",
    weight: "2.5",
    deliveryTime: "2-6",
    price: "289.99",
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  borderRadius: "10px",
  // boxShadow: 24,
  px: 2,
};

function QuoteList({ setGetShippingQuotes,setShowQuote, getShippingQuotes,formValues }) {
  const [ToggalOpen, setToggleOpen] = React.useState(false);
  const handleOpen = () => setToggleOpen(true);
  const handleClose = () => setToggleOpen(false);
  console.log(getShippingQuotes,"getShippingQuotes");

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          width: { xs: "100%", sm: "95%" },
          margin: { xs: "15px 10px 0 10px", sm: "20px 10px 0 10px", md: "24px 10px 0 10px" },
          gap: { xs: "10px", sm: "0" },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "14px", sm: "16px" },
          }}
        >
          {`${getShippingQuotes?.length||0} items found`}
        </Typography>
        <Button
          onClick={() => {setGetShippingQuotes([]);setShowQuote(false)}}
          sx={{
            width: { xs: "100%", sm: "auto" },
            minWidth: { xs: "100%", sm: "150px" },
          }}
        >
          Get a new quote
        </Button>
      </Box>
      <Grid container spacing={0} justifyContent="center">
        {getShippingQuotes&&getShippingQuotes?.map((option, index) => (
          <Grid item xs={12} md={12} key={index}>
            <Box
              sx={{ 
                marginTop: { xs: "15px", sm: "20px", md: "25px" },
                border: "1px solid #E5E5E8",
                borderRadius: { xs: "12px", sm: "16px", md: "20px" },
                width: { xs: "100%", sm: "95%" },
                marginX: { xs: "10px", sm: "auto" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "flex-start", sm: "center" },
                  justifyContent: "space-between",
                  padding: { xs: "13px 15px", sm: "13px 20px", md: "13px 30px" },
                  borderBottom: "1px solid #E5E5E8",
                  gap: { xs: "10px", sm: "0" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontWeight: "600",
                    fontSize: { xs: "14px", sm: "15px" },
                    color: "#1C2630",
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  <Box
                    component="img"
                    src={option.courier_service?.logo}
                    alt={""}
                    sx={{
                      width: { xs: "40px", sm: "50px" },
                      maxWidth: "50px",
                      height: "auto",
                      objectFit: "contain",
                    }}
                  />
                  <Box
                    component="span"
                    sx={{
                      fontSize: { xs: "13px", sm: "15px" },
                      wordBreak: "break-word",
                    }}
                  >
                    {option.courier_service?.name}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "space-between", sm: "flex-end" },
                    gap: "10px",
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: { xs: "18px", sm: "20px" },
                      color: "#1C2630",
                    }}
                  >
                    ${(option.shipment_charge_total + (option.shipment_charge_total* (option.markup/100))).toFixed(2)}
                  </Typography>
                  <Button
                    variant="outlined"
                    sx={{
                      border: "1px solid #481AA3",
                      width: { xs: "100px", sm: "122px" },
                      fontWeight: "600",
                      fontSize: { xs: "14px", sm: "16px" },
                      color: "#481AA3",
                      padding: { xs: "6px 12px", sm: "8px 16px" },
                    }}
                    onClick={handleOpen}
                  >
                    Ship Now
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
                  gap: { xs: "15px", sm: "20px" },
                  padding: { xs: "15px", sm: "20px", md: "25px" },
                  paddingBottom: "0px",
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    rowGap: { xs: "8px", sm: "14px" },
                    marginBottom: { xs: 2, sm: 3 },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "500",
                      fontSize: { xs: "14px", sm: "17px" },
                      color: "#959BA1",
                    }}
                  >
                    From Country
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "700",
                      fontSize: { xs: "16px", sm: "22px" },
                      color: "#1C2630",
                    }}
                  >
                    {formValues.originCountry}
                  </Box>
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    rowGap: { xs: "8px", sm: "14px" },
                    marginBottom: { xs: 2, sm: 3 },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "500",
                      fontSize: { xs: "14px", sm: "17px" },
                      color: "#959BA1",
                    }}
                  >
                    Dimensions
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "700",
                      fontSize: { xs: "16px", sm: "22px" },
                      color: "#1C2630",
                    }}
                  >
                    {formValues.length} * {formValues.width} *{" "}
                    {formValues.height}
                  </Box>
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    rowGap: { xs: "8px", sm: "14px" },
                    marginBottom: { xs: 2, sm: 3 },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "500",
                      fontSize: { xs: "14px", sm: "17px" },
                      color: "#959BA1",
                    }}
                  >
                    Weight
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "700",
                      fontSize: { xs: "16px", sm: "22px" },
                      color: "#1C2630",
                    }}
                  >
                    {formValues.weight}lb
                  </Box>
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    rowGap: { xs: "8px", sm: "14px" },
                    marginBottom: { xs: 2, sm: 3 },
                    gridColumn: { xs: "span 2", sm: "span 1" },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "500",
                      fontSize: { xs: "14px", sm: "17px" },
                      color: "#959BA1",
                    }}
                  >
                    Delivery time
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontWeight: "700",
                      fontSize: { xs: "16px", sm: "22px" },
                      color: "#1C2630",
                    }}
                  >
                    {option.min_delivery_time} Business days
                  </Box>
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Modal open={ToggalOpen} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95%", sm: "90%", md: "80%" },
            maxWidth: "800px",
            backgroundColor: "#ffffff",
            borderRadius: { xs: "12px", sm: "16px", md: "20px" },
            boxShadow: 24,
            p: { xs: 2, sm: 3, md: 4 },
            maxHeight: { xs: "90vh", sm: "auto" },
            overflowY: "auto",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              borderBottom: "1px solid #E5E5E8",
              pb: 1,
              position: "relative", // Ensure positioning for absolute elements
            }}
          >
            {/* Centered Text with Logo */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%", // Ensures it spans full width
                position: "relative", // To stay within the parent box
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#481AA3",
                  textAlign: "center",
                }}
              >
                {/* Logo */}
                <img
                  src={Logo}
                  alt="POSTPAL Logo"
                  style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain",
                  }}
                />
                POSTPAL
              </Box>
            </Box>

            {/* Close Button */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Main Content */}
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: "700", mb: 2, color: "#1C2630" }}
            >
              Download POSTPAL
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#5A5A5A",
                fontSize: "14px",
                mb: 4,
              }}
            >
              We've designed a seamless mobile experience to provide full
              tracking from your purchase or shipping request to final delivery.
              Stay updated every step of the way—download PostPal now!
            </Typography>
          </Box>

          {/* QR Code and App Links */}
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  justifyContent: "center",
                  gap: { xs: 2, sm: 1 },
                }}
              >
                <Box
                  component="img"
                  src={QRCode}
                  alt="QR Code"
                  sx={{
                    width: { xs: "150px", sm: "40%" },
                    height: "auto",
                    maxWidth: "200px",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "row", sm: "column" },
                    gap: { xs: 1, sm: 0.5 },
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    component="img"
                    src={Appstore}
                    alt="Appstore"
                    sx={{
                      width: { xs: "120px", sm: "60%" },
                      maxWidth: { xs: "120px", sm: "150px" },
                      height: "auto",
                      cursor: "pointer",
                    }}
                    onClick={()=>{window.open('http://Appstore.postpal.me/ios','_blank')}}
                  />
                  <Box
                    component="img"
                    src={Playstore}
                    alt="Playstore"
                    sx={{
                      width: { xs: "120px", sm: "60%" },
                      maxWidth: { xs: "120px", sm: "150px" },
                      height: "auto",
                      cursor: "pointer",
                    }}
                    onClick={()=>{window.open("http://playstore.postpal.me/android",'_blank')}}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  justifyContent: "center",
                  gap: { xs: 1, sm: 0 },
                }}
              >
                <Box
                  component="img"
                  src={MobileImageTwo}
                  alt="Get it on Google Play"
                  sx={{
                    width: { xs: "120px", sm: "150px" },
                    height: "auto",
                  }}
                />
                <Box
                  component="img"
                  src={MobileImageOne}
                  alt="Download on the App Store"
                  sx={{
                    width: { xs: "120px", sm: "150px" },
                    height: "auto",
                  }}
                />
              </Box>
            </Grid>
            {/* <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
              <img
                src={Logo}
                alt="App Preview"
                style={{ maxWidth: "100%", borderRadius: "10px" }}
              />
            </Grid> */}
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

export default QuoteList;
